import type { ComponentPropsWithoutRef, ElementType } from 'react';

export * from './mergeProps';
export * from './useAriaBusyScroll';
export * from './useCallbackRef';
export * from './useMergedRef';
export * from './useMouseDrag';
export * from './usePrefersReducedMotion';

export type Attributes<T extends ElementType> = ComponentPropsWithoutRef<T> &
  Partial<Record<`data-${string}`, string | number | boolean>> & {
    inert?: string;
  };

export function noop() {}

export function clamp(min: number, value: number, max: number) {
  if (value < min) {
    return min;
  }
  if (value > max) {
    return max;
  }
  return value;
}
